import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const departmentService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/Department`, { headers });
  },

  getDivisions: async () => {
    return await axios.get(`${domain}/api/Division`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/Department`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/Department/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/Department/${id}`, { headers });
  },
};

export default departmentService;